if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

if (!customElements.get('swiper-thumbnail-gallery')) {
  customElements.define(
    'swiper-thumbnail-gallery',
    class SwiperComponent extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.id;
        this.swiperElements = {
          wrapper: this.getElement(`[id^="SwiperThumbnailGalleryViewer-swiper-${this.sectionId}"]`),
          prev: this.getElement(`[id^="SwiperThumbnailGalleryViewer-prev-${this.sectionId}"]`),
          next: this.getElement(`[id^="SwiperThumbnailGalleryViewer-next-${this.sectionId}"]`)
        };
      }

      getElement(el) {
        return this.querySelector(el);
      }

      connectedCallback() {
        if (this.swiperElements.wrapper) {
          this.initSwiper();
          window.addEventListener('resize', this.resizeHeight.bind(this));
        }
      }

      initSwiper() {
        this.verticalDirection = this.dataset.slideDirection === 'vertical';
        this.swiperProperties = {
          resistance: true,
          resistanceRatio: 0,
          direction: "horizontal",
          effect: 'slide',
          spaceBetween: 15,
          slidesPerView: 4.5,
          mousewheelControl: true,
          touchReleaseOnEdges: true,
          centeredSlides: false,
          centeredSlidesBounds: false,
          slideToClickedSlide: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          watchOverflow: true,
          freeMode: false,
          mousewheel: {
            releaseOnEdges: true,
          },
          navigation: {
            nextEl: this.swiperElements.next,
            prevEl: this.swiperElements.prev
          },
          breakpoints: {
            750: {
              spaceBetween: 15,
              slidesPerView: 5.5,
              direction: this.dataset.slideDirection,
              centeredSlides: this.verticalDirection,
              centeredSlidesBounds: this.verticalDirection,
            },
            990: {
              spaceBetween: 15,
              slidesPerView: 5.5,
              direction: this.dataset.slideDirection,
              centeredSlides: this.verticalDirection,
              centeredSlidesBounds: this.verticalDirection,
            },
            1440: {
              spaceBetween: 15,
              slidesPerView: 5.5,
              direction: this.dataset.slideDirection,
              centeredSlides: this.verticalDirection,
              centeredSlidesBounds: this.verticalDirection,
            }
          }
        };

        this.swiper = new Swiper(this.swiperElements.wrapper, this.swiperProperties);
        this.resizeHeight();
      }

      resizeHeight() {
        const swiperWrapper = this.swiperElements.wrapper.querySelector('.swiper-wrapper').getBoundingClientRect();
        if (this.style.getPropertyValue('--swiper-slides-height') !== '')
          this.style.removeProperty('--swiper-slides-height');
        this.style.setProperty('--swiper-slides-height', `${swiperWrapper.height}px`);
      }
    }
  );
}

if(!customElements.get('swiper-gallery')) {
  customElements.define(
    'swiper-gallery',
    class SwiperComponent extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.id;
        this.swiperElements = {
          wrapper: this.getElemet(`[id^="SwiperGalleryViewer-swiper-${this.sectionId}"]`),
          prev: this.getElemet(`[id^="SwiperGalleryViewer-prev-${this.sectionId}"]`),
          next: this.getElemet(`[id^="SwiperGalleryViewer-next-${this.sectionId}"]`),
          pagination: this.getElemet(`[id^="SwiperGalleryViewer-pagination-${this.sectionId}"]`),
        };
      }

      getElemet(el) {
        return this.querySelector(el);
      }

      connectedCallback() {
        if(this.swiperElements.wrapper) {
          this.initSwiper();
          window.addEventListener('resize', this.resizeHeight.bind(this));
        };
      }

      initSwiper() {
        this.swiperProperties = {
          resistance: true,
          resistanceRatio: 0,
          effect: 'slide',
          slidesPerView: 1,
          watchOverflow: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          preventInteractionOnTransition: true,
          mousewheelControl: true,
          touchReleaseOnEdges: true,
          mousewheel: {
            releaseOnEdges: true,
          },
          pagination: {
            el: this.swiperElements.pagination,
            clickable: true,
          },
          navigation: {
            nextEl: this.swiperElements.next,
            prevEl: this.swiperElements.prev
          }
        }

        this.swiperThumbs = document.querySelector(`[id^="SwiperThumbnailGalleryViewer-${this.sectionId}"]`);
        if(this.swiperThumbs) {
          this.swiperProperties.thumbs = {
            swiper: this.swiperThumbs.swiper,
          }
        }

        this.swiper = new Swiper(this.swiperElements.wrapper, this.swiperProperties);
        this.resizeHeight();
      }

      resizeHeight() {
        const swiperWrapper = this.swiperElements.wrapper.querySelector('.swiper-wrapper').getBoundingClientRect();
        const swiperParent = this.swiperThumbs?.dataset.slideDirection === 'vertical' ? this.closest('swiper-media-gallery') : this;
        if (swiperParent && swiperParent.style.getPropertyValue('--swiper-height') !== '') 
          swiperParent.style.removeProperty('--swiper-height');
        swiperParent.style.setProperty('--swiper-height', `${swiperWrapper.height}px`);
      }
    }
  )
}

if(!customElements.get('swiper-media-gallery')) {
  customElements.define(
    'swiper-media-gallery',
    class SwiperMediaGallery extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.id;
      }
    
      connectedCallback() {
        this.swiperMain?.swiper?.on('slideChangeTransitionStart', () => {
          this.swiperThumbs?.swiper?.slideTo(this.swiperMain.swiper.activeIndex);
        });
        
        this.swiperThumbs?.swiper?.on('transitionStart', () => {
          this.swiperMain?.swiper?.slideTo(this.swiperThumbs.swiper.activeIndex);
        });
      }
    
      setActiveMedia(activeIndex) {
        if(this.swiperMain.swiper?.initialized)
          this.swiperMain.swiper?.slideTo(activeIndex);
      }
    
      get swiperMain() {
        return this.querySelector(`[id^="SwiperGalleryViewer-${this.sectionId}"]`);
      }
    
      get swiperThumbs() {
        return this.querySelector(`[id^="SwiperThumbnailGalleryViewer-${this.sectionId}"]`);
      }
    }
  );
}